import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

/* > npm install bootstrap jquery popper.js --save */
import 'bootstrap/dist/css/bootstrap.min.css';

/* Importacion de dependencias para el uso de Bootstrap */
import 'bootstrap/dist/js/bootstrap.bundle.min';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//if(window.navigator.appVersion.toLowerCase().indexOf('win') !== -1) document.body.style.zoom = "80%";
serviceWorker.unregister();